import React from "react";
import { Helmet } from "react-helmet-async";
import Contact from "../components/Contact"

function ContactPage() { 
    return(
        <div>
            <Helmet>
                <title>Contact | Adya Yoga</title>
                <meta
                  name="description"
                  content="Contact Adya Yoga to book sessions, ask questions, or plan your journey."
                />
                <link rel="canonical" href="https://yogaadya.com/contact" />
                <meta name="robots" content="index, follow" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Adya Yoga" />
                <meta property="og:title" content="Contact | Adya Yoga" />
                <meta property="og:description" content="Get in touch with Adya Yoga." />
                <meta property="og:url" content="https://yogaadya.com/contact" />
                <meta property="og:image" content="https://yogaadya.com/assets/images/yoga-01.png" />
                <meta property="og:image:secure_url" content="https://yogaadya.com/assets/images/yoga-01.png" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:image:alt" content="Adya Yoga" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Contact | Adya Yoga" />
                <meta name="twitter:description" content="Book sessions or ask questions." />
                <meta name="twitter:image" content="https://yogaadya.com/assets/images/yoga-01.png" />
                <meta name="twitter:image:alt" content="Adya Yoga" />
            </Helmet>
            <Contact />
        </div>
    )
}
export default ContactPage;